import { Card, Typography, Box } from '@mui/material';
import { CartItem } from '../../../app/data/models/cart';
import QuantitySelector from '../../../app/components/QuantitySelector';
import { formatCurrency } from '../../../app/utils/formatters';

const CartItemCard = ({
  cartItem,
  defaultTaxRate,
  onQuantityChange,
}: {
  cartItem: CartItem;
  defaultTaxRate: number;
  onQuantityChange: (quantity: number) => void;
}) => {
  const taxRate = cartItem.taxRate ?? defaultTaxRate ?? 0;
  const taxAmount = cartItem.totalPrice * (taxRate / 100);

  return (
    <Card sx={{ display: 'flex', flexDirection: 'column', p: 2 }}>
      <Box sx={{ display: 'flex' }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            bgcolor: 'grey.100',
            borderRadius: 1,
            mr: 2,
          }}
        >
          {cartItem.pictureUrl && (
            <img
              src={cartItem.pictureUrl}
              alt={cartItem.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          )}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Typography variant="h6" component="div">
              {cartItem.name}
            </Typography>
            <Typography variant="h6" color="text.primary">
              {formatCurrency(cartItem.totalPrice)}
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary">
            Tax ({taxRate}%): {formatCurrency(taxAmount)}
          </Typography>

          {cartItem.customizations && cartItem.customizations.length > 0 && (
            <Box sx={{ mt: 1 }}>
              {cartItem.customizations.map((customization) => (
                <Box key={customization.id} sx={{ mt: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    {customization.name}:
                  </Typography>
                  {customization.options.map((option) => (
                    <Typography
                      key={option.id}
                      variant="body2"
                      sx={{ ml: 2, color: 'text.secondary' }}
                    >
                      {option.name} x{option.quantity}(
                      {formatCurrency(option.price * option.quantity)})
                    </Typography>
                  ))}
                </Box>
              ))}
            </Box>
          )}

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mt={2}
          >
            <QuantitySelector
              quantity={cartItem.quantity}
              onQuantityChange={onQuantityChange}
            />
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default CartItemCard;
